var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"flex-auto mr2 bg-light-gray",staticStyle:{"height":"1px"}}),_vm._t("default"),_c('div',{staticClass:"flex-auto ml2 bg-light-gray",staticStyle:{"height":"1px"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }